import { action, observable, runInAction } from 'mobx'
import { hashHistory } from 'react-router'
import { Modal } from 'hljd'
import Api from '@api/shou_xie/showCase'
import CommonApi from '@api/common'
class Store {
  @observable searchParams = {}
  @observable showCaseList = [] //橱窗列表
  @observable loading = false
  @observable
  pagination = {
    //列表的分页
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: 10,
    total: 0
  }
  @action
  setPagination = ({ current, pageSize }) => {
    //列表分页
    this.pagination.current = current
    this.pagination.pageSize = pageSize
    this.getOrderList(current)
  }

  @observable isTotal = 0

  @action
  getShowCaseListFn = async (page = this.pagination.current) => {
    this.loading = true
    const params = this.getParams(page)
    const { data, success } = await CommonApi.showCaseListApi(params)
    this.loading = false

    if (success) {
      const { list, total_count } = data

      this.pagination.total = total_count * 1
      this.isTotal++
      this.change_show = total_count == 0 && this.isTotal == 1 ? true : false
      this.pagination.current = page
      this.showCaseList = list || []
    } else {
      this.showCaseList = []
    }
  }

  @action
  getParams = page => {
    return {
      page: page,
      per_page: this.pagination.pageSize
    }
  }

  @observable conList = [] //套餐列表
  @observable
  paginationTest = {
    //关联套餐的分页
    showQuickJumper: true,
    showTotal: total => `共 ${total} 条`,
    showSizeChanger: true,
    current: 1,
    pageSize: 6,
    total: 0
  }
  onChange = page => {
    //关联套餐的分页
    this.paginationTest.current = page
    this.getConList(page)
  }

  /**
   * 关联套餐列表
   */
  @action
  getConList = async (page = this.paginationTest.current) => {
    this.loading = true

    const params = {
      page: page,
      per_page: 6,
      is_sold_out: 0,
      commodity_type: 0,
      status: 1
    }

    const {
      data: { list, total_count },
      success
    } = await Api.setMealListApi(params)

    runInAction(() => {
      if (success) {
        this.conList = list || []
        this.paginationTest.total = total_count * 1
        this.loading = false
      }
    })
  }
  @observable isShow = false //套餐的modal
  @observable conId = ''
  @observable conSeat = ''

  @observable checkedVal = '' //选中的套餐id
  @observable is_checked = false //
  @action
  changeCheckedVal = (id, flag) => () => {
    //切换
    if (flag == 0) {
      this.is_checked = true
      this.checkedVal = id
    } else {
      this.is_checked = false
      this.checkedVal = ''
    }
  }
  cancelCon = () => {
    //取消选择
    this.loading = true
    this.conId = ''
    this.is_checked = false
    this.checkedVal = ''
    this.getShowCaseListFn(1)
    this.isShow = false
  }
  okCon = () => {
    //确定选择
    this.addSetFn()
    this.conId = ''
    this.is_checked = false
    this.checkedVal = ''
    this.conSeat = '' //选择完套餐之后清空
    this.loading = true
    this.getShowCaseListFn(1)
    this.isShow = false
  }

  /**
   * 设置关联套餐
   */
  addSetFn = async () => {
    const params = {
      id: this.conId,
      set_meal_id: this.checkedVal,
      seat: this.conSeat
    }
    const { success } = await Api.add_relative_setmealApi(params)

    if (success) {
      this.isShow = false
      this.getShowCaseListFn(1)
    }
  }

  deleteShowCaseFn = id => () => {
    let that = this
    Modal.confirm({
      content: '确定取消该套餐吗？',
      onOk() {
        that.delete_showCaseFn(id)
      }
    })
  }

  delete_showCaseFn = async id => {
    const { success } = await Api.deleteShowCaseApi({ id })

    if (success) {
      this.getShowCaseListFn(1)
    }
  }

  upSeatFn = id => () => {
    this.up_seatFn(id)
  }

  up_seatFn = async id => {
    const { success } = await Api.up_seatApi({ id })

    if (success) {
      this.getShowCaseListFn(1)
    }
  }

  //ModalBox
  @observable change_show = false

  @action
  onCancel = () => {
    this.modalIf.isShow = false
  }

  @observable
  modalIf = {
    type1: '',
    isShow: false,
    btn1: '',
    btn2: '',
    content: ''
  }

  @observable bigQrCote = false

  @action
  showQrCote = () => {
    this.bigQrCote = true
  }

  @action
  hideQrCote = () => {
    this.bigQrCote = false
  }

  /**
   * 大图模式进入编辑
   */
  linkToFn = (id, seat, showCaseEntry) => () => {
    hashHistory.push({
      pathname: '/localMerchant/showCase/info/' + id + '/' + seat,
      state: {
        showCaseEntry
      }
    })
  }
}
export default new Store()
